import { render, staticRenderFns } from "./KnowledgeView.vue?vue&type=template&id=64499c1d&scoped=true&"
import script from "./KnowledgeView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeView.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeView.vue?vue&type=style&index=0&id=64499c1d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64499c1d",
  null
  
)

export default component.exports